import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
  } from '@material-ui/core';
  import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
  import { Box, Button, Card, FormControlLabel, FormLabel, Grid, Icon, MenuItem, Radio, RadioGroup, TableFooter, TextField, styled } from "@mui/material";
  import { Loader } from "app/components";
  import { getAllConstructionNameListByParameters, getAllProjectLocationListForReportsByStatus } from "app/redux/actions/ProjectLocationActions";
  import { getConstructionNameBOQContractReport, getConstructionNameBOQEstimateReport, getProjectConstructionNameBOQDOMReport } from "app/redux/actions/ReportsAction";
  import { AppConstants } from "app/utils/AppConstants";
  import { ServiceUrl } from 'app/utils/Constants';
import { getStatusByRole, ProjectStatus, UserRole } from 'app/utils/ProjectStatus';
  import { SnackBarProperty } from "app/utils/SnackBarProperty";
  import { checkValidation, currencyFormat, formatNumberWithCommasAndDecimals, getCurrentRole, getTwoDigitDecimal } from "app/utils/utils";
  import { SimpleCard } from "components";
  import html2canvas from "html2canvas";
  import jsPDF from "jspdf";
  import 'jspdf-autotable';
  import { useSnackbar } from "notistack";
  import React, { useEffect, useState } from "react";
  import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
  import { useDispatch, useSelector } from "react-redux";
  
  
  const styles = {
    tableCell: {
      textAlign: "center"
    },
    subHeader: {
      textAlign: "center",
      fontWeight: 700
    }
  
  }
  const DecoratedTextField = styled(TextValidator)(() => ({
    width: "100%",
    marginBottom: "16px",
  }));
  
  
  
  
  export const ConstructionNameBoQDomReport = ({state}) => {
  
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isDownloading, setIsDownloading] = useState(false)
    const [isPrinting, setIsPrinting] = useState(false)
    const [constructionNameList, setConstructionNameList] = useState([])
    const [projectDetails, setProjectDetails] = useState()
    const [totalAmount, setTotalAmount] = useState()
    const { reportsProjectLocationList } = useSelector((state) => state.projectLocation);
    const [tableData, setTableData] = useState()

    const showLoader = () => {
      setLoading(true)
    }

    const showToast = (msg) => {
      const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
  
    const hideLoader = () => {
      setLoading(false)
    }

      useEffect(() => {
        handleFormSubmit()
      },[state])

    const handleFormSubmit = () => {
      setTableData([])
      setLoading(true)
        const params = { constructionname_id: state?.constructionname_id, projectlocation_id: state?.project_location_id }
        getProjectConstructionNameBOQDOMReport(params).then((res) => {
            setLoading(false)
            if (res?.status < 300) {
              const responseObj = res?.data?.obj
              if (responseObj?.item?.length > 0) {
                const groupedItems = Object.values(
                responseObj?.item?.reduce((acc, item) => {
                  // Define grouping key (similar items)
                  const key = `${item.constructionname_id}-${item.item_code}`;

                  // If new group, initialize
                  if (!acc[key]) {
                    acc[key] = {
                      constructionname_id: item.constructionname_id,
                      item_code: item.item_code,
                      description: item.description,
                      project_name: item.project_name,
                      construction_name: item.construction_name,
                      project_id: item.project_id,
                      dzongkhag_name: item.dzongkhag_name,
                      unit_name: item.unit_name,
                      bsr_year: item.bsr_year,
                      project_location_id: item.project_location_id,
                      children: [],
                      quantity: 0
                    };
                  }

                  // Push only varying fields into child array
                  acc[key].children.push({
                    item_no: item.item_no,
                    item_sign: item.item_sign,
                    height: item.height,
                    breadth: item.breadth,
                    length: item.length,
                    quantity: item.quantity,
                    remarks: item.remarks,
                  });
                  acc[key].quantity += item.quantity;
                  return acc;
                }, {})
              ).sort((a, b) => a.item_code.localeCompare(b.item_code));

              console.log('grouped items', groupedItems)
              setTableData(groupedItems)
              const projectDetails = responseObj?.item[0]
                setProjectDetails({
                  construction_name: projectDetails?.construction_name,
                  project_location: projectDetails?.project_location,
                  project_name: projectDetails?.project_name,
                  project_id: projectDetails?.project_id,
                  header: responseObj?.header_logo,
                  footer: responseObj?.footer_logo,
                })
             
              }
              else {
                const key = enqueueSnackbar('No data found', { variant: 'info' });
                SnackBarProperty.info(key, closeSnackbar);
              }
            }
            else {
              const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
              SnackBarProperty.error(key, closeSnackbar);
  
            }
          }).catch(error => {
            setLoading(false)
  
            const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
            SnackBarProperty.error(key, closeSnackbar);
  
          })
    }
  
    const handleDownload = (isPrint) => {
      if (isPrint) {
        setIsPrinting(true)
        setIsDownloading(false)
      }
      else {
        setIsPrinting(false)
        setIsDownloading(true)
      }
      const doc = new jsPDF();
  
      doc.setFontSize(12); // Set font size
  
        const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
        const textX = 15;
        const textY = headerHeight // Adjust the value for vertical separation
  
        // Add the text content below the header image
        doc.setFont('helvetica', 'bold'); // Set font to bold
        doc.setFontSize(12); // Set font size
        doc.text("Construction Name BOQ DOM", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("Construction Name BOQ DOM") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);
        // doc.text(`Bill of Quantities (${reportType === "estimate" ? "Estimate" : "Contract"})`, textX, textY);
        doc.setFontSize(8); // Set font size
        const textWidth = doc.getStringUnitWidth("Construction Name:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
        doc.text("Project Name:", textX, textY + 10);
        doc.setFont('helvetica', 'normal');
        doc.text(state?.project_name, textX + textWidth + 5, textY + 10);
        doc.setFont('helvetica', 'bold');
        doc.text("Project ID:", textX, textY + 15);
        doc.setFont('helvetica', 'normal');
        doc.text(state?.project_id, textX + textWidth + 5, textY + 15);
        doc.setFont('helvetica', 'bold');
        doc.text("Construction Name:", textX, textY + 20);
        doc.setFont('helvetica', 'normal');
        doc.text(projectDetails?.construction_name, textX + textWidth + 5, textY + 20);
        doc.setFont('helvetica', 'bold');
        // doc.text("Dzongkhag:", textX, textY + 20);
        // doc.setFont('helvetica', 'normal');
        // doc.text(`${projectDetails?.dzongkhag_name}`, textX + textWidth + 5, textY + 20);
        // doc.setFont('helvetica', 'bold');
        // doc.text("BSR Year:", textX, textY + 25);
        // doc.setFont('helvetica', 'normal');
        // doc.text(`${projectDetails?.bsr_year}`, textX + textWidth + 5, textY + 25);
  
        const headerSectionHeight = headerHeight + 25; // Adjust the value as needed
  
        // Calculate the starting Y-coordinate for the table
        const tableStartY = headerSectionHeight + 5;
        doc.setFont('helvetica', 'normal');
  
        function transformData(data) {
          const transformedData = [];
          var rowIndex = 0
          data.forEach((row, index) => {
  
            // Create a row for the section header value (spanning across all 8 columns)
            const headerItemCodeRow = [{ content: `Item Code: ${row?.item_code}`, colSpan: 8, styles: { fontStyle: "bold", fontSize: 8 } }];
            transformedData.push(headerItemCodeRow);
            const headerDescriptionRow = [{ content: `Item Description: ${row?.description}`, colSpan: 8, styles: { fontStyle: "bold", fontSize: 8 } }];
            transformedData.push(headerDescriptionRow);
            const headerUnitNameRow = [{ content: `Unit Name: ${row?.unit_name}`, colSpan: 8, styles: { fontStyle: "bold", fontSize: 8 } }];
            transformedData.push(headerUnitNameRow);
  
            // Loop through the data of the section and create rows for each object in the data
  
            row.children.forEach((row, index) => {
              // rowIndex+=1
              // const rowData = Object.values(row);
  
            //   const rate = formatNumberWithCommasAndDecimals(rowData?.amount)
            //   rowData.amount = rate// Extract values of each object
  
              transformedData.push([
                // { content: index+1, styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.item_no), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.length), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.breadth), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.height), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.item_sign), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: currencyFormat(row?.quantity), styles: { valign: "middle", halign: "center",fontSize: 8 } },
                { content: row?.remarks, styles: { valign: "middle", halign: "center",fontSize: 8 } },
              ]);
            });
            transformedData.push([
              { content: `Item Quantity: ${currencyFormat(row?.quantity)}`, colSpan: 8, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
            //   { content: `${section?.total ?? "0.00"}`, colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
            ])
          });
          return transformedData;
        }
  
        const transformedData = transformData(tableData);
       
  
        doc.autoTable({
            margin: { 
            top: 30,      // push below header
            bottom: 30    // leave space above footer
          },
          startY: tableStartY,
          head: [[
            // { content: "SL NO.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "NO", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "LENGTH", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "BREADTH", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "HEIGHT", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "DEDUCTIONS", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "QUANTITY", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
            { content: "REMARKS", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }

          ]],
          body: transformedData, // Use the transformed data here
          theme: "grid",
          styles: {
            fillColor: [255, 255, 255], // Remove background color from the table
            lineColor: [0, 0, 0], // Set border color for main table
            lineWidth: 0.1, // Set border width for main table
            textColor: [0, 0, 0], // Set text color to black
            cellPadding: 2, // Add padding to cells
          },
          columnStyles: {
            2: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
            5: { halign: "right" }, // "RATE" column width
            6: { halign: "right" }, // "AMOUNT" column width
            3: { halign: "right" }, // "UNIT" column width
          },
        });
  
        const totalNumPages = doc.internal.getNumberOfPages();

      // Loop through each page to add the footer with page numbers
      for (let i = 1; i <= totalNumPages; i++) {
  
        const pdfWidth = doc.internal.pageSize.getWidth() - 30;
  
        // Header
        const headerHeight = 20;
        const headerX = 15;
        const headerY = 0; // at the very top
        if (checkValidation(projectDetails?.header)) {
          doc.addImage(
            `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
            headerX,
            headerY,
            pdfWidth,
            headerHeight
          );
        }
  
        //Footer
        const footerX = 15; // Starting X position for the footer
        const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
        const footerHeight = 20;
        doc.setPage(i);
        if (checkValidation(projectDetails?.footer)) {
          doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
        }
      }
  
        const scaleFactor = 1.0; // Adjust this value as needed
        const pdfBlob = doc.output('blob', { scale: scaleFactor });
  
        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);
  
        // Open a new window with the PDF URL
  
        if (isPrint) {
          const newWindow = window.open(pdfUrl, '_blank');
  
          // After the new window is opened, you can close the URL object
          URL.revokeObjectURL(pdfUrl);
          if (newWindow) {
            newWindow.onload = () => {
              setIsPrinting(false)
              setIsDownloading(false)
              // Wait for the window to load and then trigger the print dialog
              newWindow.print();
            };
          }
        }
  
        setIsPrinting(false)
        setIsDownloading(false)
  
        isPrint === false && doc.save('ConstructionNameBoQ_DOM_Report.pdf');
    };
  
  
    return (
      <>
        <div style={{ height: 'auto', width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
         
          
          {tableData && tableData?.length > 0 && 
          <Grid container>
            <Grid xs={12} md={6}>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  color="warning"
                  startIcon={<CloudDownload />}
                  onClick={() => { handleDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  color="primary"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<Print />}
                  onClick={() => { handleDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>
  
          </Grid>}
          {tableData && tableData?.length > 0 && 
          <Card sx={{ padding: 3 }}>
            <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
              <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "10px", alignItems: "center" }}>
                {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "100px", width: "100%" }} alt="img" />
                  }  
                </div>
  
                <Grid container spacing={0} >
                  <Grid item xs={12} align='center' >
                    <FormLabel sx={{ fontSize: 22 }} ><b>Construction Name BOQ DOM</b></FormLabel>
                  </Grid>
  
                  <Grid item xs={12} sx={{ marginTop: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{projectDetails?.project_id}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Construction Name: </b>{projectDetails?.construction_name}</FormLabel>
                  </Grid>
                  {/* <Grid item xs={12} >
                    <FormLabel sx={{ fontSize: 18 }}><b>Dzongkhag: </b>{projectDetails?.dzongkhag_name}</FormLabel>
                  </Grid>
                  <Grid item xs={12} >
                    <FormLabel sx={{ fontSize: 18 }}><b>BSR Year: </b>{projectDetails?.bsr_year}</FormLabel>
                  </Grid> */}
                </Grid>
              </div>
  
              <div id="tableData">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead style={{ backgroundColor: '#87CEEB' }}>
                      <TableRow>
                        {/* <TableCell>Sl No.</TableCell> */}
                        <TableCell align="right">NO</TableCell>
                        <TableCell align="right">LENGTH</TableCell>
                        <TableCell align="right">BREADTH</TableCell>
                        <TableCell align="right">HEIGHT</TableCell>
                        <TableCell align="center">DEDUCTIONS</TableCell>
                        <TableCell align="right">QUANTITY</TableCell>
                        <TableCell>REMARKS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* {tableData?.map((section) => (
                        <React.Fragment key={section.stageName}>
                          <TableRow>
                            <TableCell colSpan={7}>{section.stageName}</TableCell>
                          </TableRow> */}
                          {tableData?.map((row, index) => (
                            <React.Fragment key={row.item_code}>
                            <TableRow key={index}>
                            <TableCell colSpan={8}>
                                <p><b>Item Code:</b> {row.item_code}</p>
                            </TableCell>
                            </TableRow>
                            <TableRow key={index}>
                            <TableCell colSpan={8}>
                            <p><b>Item Description:</b> {row.description}</p>
                            </TableCell>
                            </TableRow>
                            <TableRow key={index}>
                            <TableCell colSpan={8}>
                            <p><b>Unit:</b> {row.unit_name}</p>
                            </TableCell>
                             </TableRow>

                            {row?.children?.map((row, index) => (
                            <TableRow>
                              {/* <TableCell>{index+1}</TableCell> */}
                              <TableCell align="right">{currencyFormat(row?.item_no)}</TableCell>
                              <TableCell align="right">{currencyFormat(row?.length)}</TableCell>
                              <TableCell align="right">{currencyFormat(row?.breadth)}</TableCell>
                              <TableCell align="right">{currencyFormat(row?.height)}</TableCell>
                              <TableCell align="center">{row.item_sign}</TableCell>
                              <TableCell align="right">{currencyFormat(row?.quantity)}</TableCell>
                              <TableCell>{row?.remarks}</TableCell>
                            </TableRow>
                            ))}
                            <TableRow key={index}>
                                <TableCell align="right" colSpan={8}>
                                <p><b>Item Quantity:</b> {currencyFormat(row?.quantity)}</p>
                                </TableCell>
                            </TableRow>
                            </React.Fragment>
                          ))}
                         
                    </TableBody>
  
                  </Table>
                  
                </TableContainer>
  
              </div>
            </div>
          </Card>}
  
        </div>
        {loading && (
          <Loader
            show={loading}
          />
        )}
        {(isPrinting || isDownloading) && (
          <Loader
            show={isPrinting ? isPrinting : isDownloading}
            text="Processing...Please wait."
          />
        )}
  
      </>
    )
  }